import axios, { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { IProvider } from '../../models';
import { queryKeys } from '../../../shared';

async function getProviders(onGetErrorMessage?: string): Promise<IProvider[]> {
    const { data } = await axios.get('/auth/providers', { errorMessage: onGetErrorMessage });
    return data;
}

export const useGetProviders = () => {
    const { t } = useTranslation();
    return useQuery<IProvider[], AxiosError>({
        queryKey: [queryKeys.AUTH_PROVIDERS],
        queryFn: () => getProviders(t('getProvidersError')),
    });
};
